var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goto_home",on:{"click":_vm.gotoHome}},[_c('van-icon',{staticClass:"icon",attrs:{"name":"wap-home"}}),_vm._v("\n  首页\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }